module.exports = __webpack_public_path__ + "static/banner-f9b2871f75b2230e8115292ba206b57b.png";